import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";


export function ApolloLabel(props: { label: string, fontSize?: string}) {
  const {label, fontSize} = props;
  const size = fontSize? fontSize: "20px";

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Typography style={{fontSize: size}}>{label}</Typography>
      </Grid>
    </React.Fragment>
  );
}
